import { Pipe, PipeTransform } from '@angular/core';
import { ColorUtility } from '@jms/model';

@Pipe({
  name: 'textColor',
  pure: false,
  standalone: true
})
export class TextColorPipe implements PipeTransform {
  transform(textColor: string) {

    if (textColor === 'transparent') {
      textColor = '#ffffff';
    }

    return ColorUtility.idealTextColor(textColor);
  }
}
